import { Menu, styled } from "@mui/material";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.wsc.palette.neutral[700],
    color: theme.wsc.palette.neutral[100],
    borderRadius: theme.wsc.radius.m,

    "& .MuiMenu-list": {
      display: "flex",
      flexDirection: "column",
      gap: theme.wsc.spacing[1],
    },

    "& .MuiMenuItem-root": {
      minHeight: "2.8rem",

      "&:hover": {
        backgroundColor: theme.wsc.palette.neutral[600],
      },

      "&.Mui-selected": {
        backgroundColor: theme.wsc.palette.neutral[500],
        fontWeight: theme.wsc.typography.body1bold.fontWeight,
      },
    },
  },
}));
